export const AdminPage = () => {
  return (
    <div>
      <h3>Admin Page</h3>
      <div>This page is for admins</div>
    </div>
  );
};